module.exports = new __parcel__URL__("Brickfilms.7857e968.avif").toString();